import { FC } from "react";
import { Link } from "react-router";
import { Button, Text } from "@postenbring/hedwig-react";
import Translated from "../infrastructure/translation/Translated";
import { TranslationKey } from "../infrastructure/translation/translator";
import styles from "./SectionHeader.module.css";

interface SectionHeaderProps {
  titleKey: TranslationKey;
  descriptionKey: TranslationKey;
  actionKey: TranslationKey;
  actionTo: string;
}

export const SectionHeader: FC<SectionHeaderProps> = ({
  titleKey,
  descriptionKey,
  actionKey,
  actionTo,
}) => (
  <div className={styles.sectionHeader}>
    <div className={styles.sectionHeaderText}>
      <Text variant="h3" as="h2" size="min">
        <Translated textKey={titleKey} />
      </Text>
      <Text variant="body-small">
        <Translated textKey={descriptionKey} />
      </Text>
    </div>
    <Button size="small" asChild>
      <Link to={actionTo}>
        <Translated textKey={actionKey} />
      </Link>
    </Button>
  </div>
);
